import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

/**
 * Amber pulsing chip on assets the agents are STILL ITERATING on (no acceptance
 * event yet) — comment once it disappears; the asset is final/QC-approved then.
 */
export default function IteratingChip() {
  const { t } = useTranslation('production');
  return (
    <span
      className="absolute bottom-6 left-1 z-10 flex animate-pulse items-center gap-1 rounded
                 bg-amber-500/90 px-1.5 py-0.5 text-[9px] font-bold text-black"
    >
      <Loader2 className="h-2.5 w-2.5 animate-spin" />
      {t('tile.iterating')}
    </span>
  );
}
